import { observable } from 'mobx';

export type HotelReservationResponseArgs = {
  id: number;
  status: 'enqueued' | 'running' | 'success' | 'fail';
  error?: string;
};

export type HotelReservationArgs = {
  id: number;
  status: 'enqueued' | 'running' | 'success' | 'fail';
  error?: string;
};

export const convertHotelReservationResponseToArgs = (
  response: HotelReservationResponseArgs
): HotelReservationArgs => {
  return {
    id: response.id,
    status: response.status,
    error: response.error
  };
};

export default class HotelReservation {
  @observable id: number;
  @observable status: 'enqueued' | 'running' | 'success' | 'fail';
  @observable error?: string;

  constructor(args: HotelReservationArgs) {
    this.id = args.id;
    this.status = args.status;
    this.error = args.error;
  }

  statusDescription(): string {
    return {
      enqueued: '開始中',
      running: '実行中',
      success: '成功',
      fail: '失敗'
    }[this.status];
  }
}
